export default __webpack_public_path__ + "static/media/22.4dfe81b7.png";